module.exports = __webpack_public_path__ + "3aa095c4676bbd98bcbef46119b9b180.png";